import { createTypes, createAction } from 'lib/action'

// *load ข้อมูลโรงงาน
const QUICK_TEST_LOAD_LOCATION = createTypes('quickTestLoadLocation', 'load')

// *load ข้อมูลต้นแหล่งสำหรับ create
const QUICK_TEST_LOAD_SOURCE_LOCATION_FOR_CREATE = createTypes(
  'quickTestLoadSourceLocationForCreate',
  'load'
)

// *load ข้อมูลต้นแหล่งสำหรับค้นหา
const QUICK_TEST_LOAD_SOURCE_LOCATION = createTypes(
  'quickTestLoadSourceLocation',
  'load'
)

// *load ข้อมูลต้นแหล่งทราย
const QUICK_TEST_LOAD_ORIGIN_LOCATION_SAND = createTypes(
  'quickTestLoadOriginLocationSand',
  'load'
)

// *load ข้อมูลต้นแหล่งหิน
const QUICK_TEST_LOAD_ORIGIN_LOCATION_ROCK = createTypes(
  'quickTestLoadOriginLocationRock',
  'load'
)

// *load ข้อมูล preview
const QUICK_TEST_PREVIEW = createTypes('quickTestPreview', 'load')

// *ดึงข้อมูล quick test by id
const QUICK_TEST_GET_BY_ID = createTypes('quickTestGetById', 'load')

// *ดึงรายการ Quick Test
const QUICK_TEST_GET_LIST = createTypes('quickTestGetList', 'load')

// *create ข้อมูล Quick Test
const QUICK_TEST_CREATE = createTypes('quickTestCreate', 'create')

// *update ข้อมูล Quick Test
const QUICK_TEST_UPDATE = createTypes('quickTestUpdate', 'update')

// *delete ข้อมูล Quick Test
const QUICK_TEST_DELETE = createTypes('quickTestDelete', 'delete')

// *export excel
const QUICK_TEST_EXPORT_EXCEL = createTypes('quickTestExportExcel', 'export')

// *import quicktest data
const QUICK_TEST_IMPORT_EXCEL = createTypes('quickTestImportExcel', 'import')

// *load ข้อมูลต้นแหล่งหิน for search
const QUICK_TEST_LOAD_ORIGIN_LOCATION_ROCK_FOR_SEARCH = createTypes(
  'quickTestLoadOriginLocationRockForSearch',
  'load'
)
// *load ข้อมูลต้นแหล่งทราย for search
const QUICK_TEST_LOAD_ORIGIN_LOCATION_SAND_FOR_SEARCH = createTypes(
  'quickTestLoadOriginLocationSandForSearch',
  'load'
)

// *load division
const QUICK_TEST_EVALUATION_LOAD_DIVISION = createTypes(
  'quickTestLoadDivision',
  'load'
)

// *load department
const QUICK_TEST_EVALUATION_LOAD_DEPARTMENT = createTypes(
  'quickTestLoadDepartment',
  'load'
)

// *load section
const QUICK_TEST_EVALUATION_LOAD_SECTION = createTypes(
  'quickTestLoadSection',
  'load'
)

// *load plant
const QUICK_TEST_EVALUATION_LOAD_PLANT = createTypes(
  'quickTestLoadPlant',
  'load'
)

// *remove lists
const REMOVE_LISTS = `REMOVE_LISTS`

// *remove lists
function removeLists() {
  return {
    type: REMOVE_LISTS,
  }
}

// *load ข้อมูลโรงงาน
const quickTestLoadLocation = {
  request: (data) =>
    createAction(QUICK_TEST_LOAD_LOCATION.REQUEST, {
      data,
    }),
  success: (lists) => createAction(QUICK_TEST_LOAD_LOCATION.SUCCESS, { lists }),
  failure: () => createAction(QUICK_TEST_LOAD_LOCATION.FAILURE),
}

// *load ข้อมูลต้นแหล่งสำหรับ create
const quickTestLoadSourceLocationForCreate = {
  request: (data) =>
    createAction(QUICK_TEST_LOAD_SOURCE_LOCATION_FOR_CREATE.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(QUICK_TEST_LOAD_SOURCE_LOCATION_FOR_CREATE.SUCCESS, { lists }),
  failure: () =>
    createAction(QUICK_TEST_LOAD_SOURCE_LOCATION_FOR_CREATE.FAILURE),
}

// *load ข้อมูลต้นแหล่งสำหรับค้นหา
const quickTestLoadSourceLocation = {
  request: (data) =>
    createAction(QUICK_TEST_LOAD_SOURCE_LOCATION.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(QUICK_TEST_LOAD_SOURCE_LOCATION.SUCCESS, { lists }),
  failure: () => createAction(QUICK_TEST_LOAD_SOURCE_LOCATION.FAILURE),
}

// *load ข้อมูลต้นแหล่งทราย
const quickTestLoadOriginLocationSand = {
  request: (data) =>
    createAction(QUICK_TEST_LOAD_ORIGIN_LOCATION_SAND.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(QUICK_TEST_LOAD_ORIGIN_LOCATION_SAND.SUCCESS, { lists }),
  failure: () => createAction(QUICK_TEST_LOAD_ORIGIN_LOCATION_SAND.FAILURE),
}

// *load ข้อมูลต้นแหล่งหิน
const quickTestLoadOriginLocationRock = {
  request: (data) =>
    createAction(QUICK_TEST_LOAD_ORIGIN_LOCATION_ROCK.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(QUICK_TEST_LOAD_ORIGIN_LOCATION_ROCK.SUCCESS, { lists }),
  failure: () => createAction(QUICK_TEST_LOAD_ORIGIN_LOCATION_ROCK.FAILURE),
}

// *load ข้อมูล preview
const quickTestPreview = {
  request: (data) =>
    createAction(QUICK_TEST_PREVIEW.REQUEST, {
      data,
    }),
  success: (lists) => createAction(QUICK_TEST_PREVIEW.SUCCESS, { lists }),
  failure: () => createAction(QUICK_TEST_PREVIEW.FAILURE),
}

// *ดึงข้อมูล quick test by id
const quickTestGetById = {
  request: (data) =>
    createAction(QUICK_TEST_GET_BY_ID.REQUEST, {
      data,
    }),
  success: (lists) => createAction(QUICK_TEST_GET_BY_ID.SUCCESS, { lists }),
  failure: () => createAction(QUICK_TEST_GET_BY_ID.FAILURE),
}

// *ดึงรายการ Quick Test
const quickTestGetList = {
  request: (data) =>
    createAction(QUICK_TEST_GET_LIST.REQUEST, {
      data,
    }),
  success: (lists) => createAction(QUICK_TEST_GET_LIST.SUCCESS, { lists }),
  failure: () => createAction(QUICK_TEST_GET_LIST.FAILURE),
}

// *create ข้อมูล Quick Test
const quickTestCreate = {
  request: (data) =>
    createAction(QUICK_TEST_CREATE.REQUEST, {
      data,
    }),
  success: (lists) => createAction(QUICK_TEST_CREATE.SUCCESS, { lists }),
  failure: () => createAction(QUICK_TEST_CREATE.FAILURE),
}

// *update ข้อมูล Quick Test
const quickTestUpdate = {
  request: (data) =>
    createAction(QUICK_TEST_UPDATE.REQUEST, {
      data,
    }),
  success: (lists) => createAction(QUICK_TEST_UPDATE.SUCCESS, { lists }),
  failure: () => createAction(QUICK_TEST_UPDATE.FAILURE),
}

// *delete ข้อมูล Quick Test
const quickTestDelete = {
  request: (data) =>
    createAction(QUICK_TEST_DELETE.REQUEST, {
      data,
    }),
  success: (lists) => createAction(QUICK_TEST_DELETE.SUCCESS, { lists }),
  failure: () => createAction(QUICK_TEST_DELETE.FAILURE),
}

// *export excel
const quickTestExportExcel = {
  request: (data) =>
    createAction(QUICK_TEST_EXPORT_EXCEL.REQUEST, {
      data,
    }),
  success: (lists) => createAction(QUICK_TEST_EXPORT_EXCEL.SUCCESS, { lists }),
  failure: () => createAction(QUICK_TEST_EXPORT_EXCEL.FAILURE),
}

// *import quicktest data
const quickTestImportExcel = {
  request: (data, loading) =>
    createAction(QUICK_TEST_IMPORT_EXCEL.REQUEST, { data, loading }),
  success: (res) => createAction(QUICK_TEST_IMPORT_EXCEL.SUCCESS, { res }),
  failure: () => createAction(QUICK_TEST_IMPORT_EXCEL.FAILURE),
}

// *load ข้อมูลต้นแหล่งหิน
const quickTestLoadOriginLocationRockForSearch = {
  request: (data) =>
    createAction(QUICK_TEST_LOAD_ORIGIN_LOCATION_ROCK_FOR_SEARCH.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(QUICK_TEST_LOAD_ORIGIN_LOCATION_ROCK_FOR_SEARCH.SUCCESS, {
      lists,
    }),
  failure: () =>
    createAction(QUICK_TEST_LOAD_ORIGIN_LOCATION_ROCK_FOR_SEARCH.FAILURE),
}

// *load ข้อมูลต้นแหล่งทราย
const quickTestLoadOriginLocationSandForSearch = {
  request: (data) =>
    createAction(QUICK_TEST_LOAD_ORIGIN_LOCATION_SAND_FOR_SEARCH.REQUEST, {
      data,
    }),
  success: (lists) =>
    createAction(QUICK_TEST_LOAD_ORIGIN_LOCATION_SAND_FOR_SEARCH.SUCCESS, {
      lists,
    }),
  failure: () =>
    createAction(QUICK_TEST_LOAD_ORIGIN_LOCATION_SAND_FOR_SEARCH.FAILURE),
}

// *load division
const quickTestLoadDivision = {
  request: (data, loading) =>
    createAction(QUICK_TEST_EVALUATION_LOAD_DIVISION.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(QUICK_TEST_EVALUATION_LOAD_DIVISION.SUCCESS, { lists }),
  failure: () => createAction(QUICK_TEST_EVALUATION_LOAD_DIVISION.FAILURE),
}

// *load department
const quickTestLoadDepartment = {
  request: (data, loading) =>
    createAction(QUICK_TEST_EVALUATION_LOAD_DEPARTMENT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(QUICK_TEST_EVALUATION_LOAD_DEPARTMENT.SUCCESS, { lists }),
  failure: () => createAction(QUICK_TEST_EVALUATION_LOAD_DEPARTMENT.FAILURE),
}

// *load section
const quickTestLoadSection = {
  request: (data, loading) =>
    createAction(QUICK_TEST_EVALUATION_LOAD_SECTION.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(QUICK_TEST_EVALUATION_LOAD_SECTION.SUCCESS, { lists }),
  failure: () => createAction(QUICK_TEST_EVALUATION_LOAD_SECTION.FAILURE),
}

// *load plant
const quickTestLoadPlant = {
  request: (data, loading) =>
    createAction(QUICK_TEST_EVALUATION_LOAD_PLANT.REQUEST, {
      data,
      loading,
    }),
  success: (lists) =>
    createAction(QUICK_TEST_EVALUATION_LOAD_PLANT.SUCCESS, { lists }),
  failure: () => createAction(QUICK_TEST_EVALUATION_LOAD_PLANT.FAILURE),
}

export {
  REMOVE_LISTS,
  removeLists,
  QUICK_TEST_LOAD_LOCATION,
  quickTestLoadLocation,
  QUICK_TEST_LOAD_SOURCE_LOCATION,
  quickTestLoadSourceLocationForCreate,
  QUICK_TEST_LOAD_SOURCE_LOCATION_FOR_CREATE,
  quickTestLoadSourceLocation,
  QUICK_TEST_LOAD_ORIGIN_LOCATION_SAND,
  quickTestLoadOriginLocationSand,
  QUICK_TEST_LOAD_ORIGIN_LOCATION_ROCK,
  quickTestLoadOriginLocationRock,
  QUICK_TEST_PREVIEW,
  quickTestPreview,
  QUICK_TEST_GET_BY_ID,
  quickTestGetById,
  QUICK_TEST_GET_LIST,
  quickTestGetList,
  QUICK_TEST_CREATE,
  quickTestCreate,
  QUICK_TEST_UPDATE,
  quickTestUpdate,
  QUICK_TEST_DELETE,
  quickTestDelete,
  QUICK_TEST_EXPORT_EXCEL,
  quickTestExportExcel,
  QUICK_TEST_IMPORT_EXCEL,
  quickTestImportExcel,
  QUICK_TEST_LOAD_ORIGIN_LOCATION_ROCK_FOR_SEARCH,
  quickTestLoadOriginLocationRockForSearch,
  QUICK_TEST_LOAD_ORIGIN_LOCATION_SAND_FOR_SEARCH,
  quickTestLoadOriginLocationSandForSearch,
  QUICK_TEST_EVALUATION_LOAD_DIVISION,
  quickTestLoadDivision,
  QUICK_TEST_EVALUATION_LOAD_DEPARTMENT,
  quickTestLoadDepartment,
  QUICK_TEST_EVALUATION_LOAD_SECTION,
  quickTestLoadSection,
  QUICK_TEST_EVALUATION_LOAD_PLANT,
  quickTestLoadPlant,
}
